import { FC, useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/auth.context.tsx';

const RetailerRoute: FC = () => {
	const location = useLocation();
	const { isAuthenticated, user } = useContext(AuthContext);

	return isAuthenticated && user?.role === 'retailer' ? (
		<Outlet />
	) : (
		<Navigate
			to="/login"
			state={{ from: location }}
			replace
		/>
	);
};

export default RetailerRoute;
